import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="regulatory_updates" />;

export const Route = createFileRoute("/es/actualizaciones-regulatorias/$slug")({
  loader: ({ params }) => loadContentMeta("regulatory_updates", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/actualizaciones-regulatorias/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

